/**
 * Copyright (c) 2021, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import { useAuthContext } from "@asgardeo/auth-react";
import React, { FunctionComponent, ReactElement } from "react";
import { Redirect } from "react-router-dom";
import { GlobalLoader } from "../components";
import { IdentifiableComponentInterface } from "../models/core";

/**
 * Application Landing page props interface.
 */
export interface LandingPropsInterface extends IdentifiableComponentInterface {
    /**
     * Client Identifier of the application.
     */
    clientID: string;
}

/**
 * Landing page.
 *
 * TODO: Check If this page is functionally necessary.
 * In the Router, adding a redirect to `/home` should be enough.
 *
 * @param {LandingPropsInterface} props - Props injected to the component.
 * @return {React.ReactElement}
 */
export const LoginPage: FunctionComponent<LandingPropsInterface> =(
    props: LandingPropsInterface
): ReactElement => {

    const {
        ["data-componentid"]: componentId
    } = props;

    /**
     * Desctructuring the context from `useAuthContext` hook.
     * 
     */
    const { state } = useAuthContext();

    return(
        <div data-componentid = { componentId }>
            {
                state.isAuthenticated
                    ? (
                        <div>   
                            <Redirect to="/home"></Redirect>
                        </div>
                    )
                    : <GlobalLoader data-componentid="loged-in-page-global-loader" />
            }
        </div>
    );
};
